import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import {
  Form,
  OriCheckbox,
  OriNumberInput,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import AtDiscountValue from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/AtDiscountValue';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/DiscountLastExpression';
import ProductsCollectionRadioTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductsCollectionRadioTable';
import { isInteger, isNumber } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';
const Item = Form.Item;
const ItemShouldUpdate = Form.ShouldUpdate;

export enum DiscountValueType {
  Free = 'Free',
  Percentage = 'Percentage',
  Reduction = 'Reduction',
}

export enum CumulativeType {
  ConditionOnly = 'ConditionOnly',
  ConditionCumulative = 'ConditionCumulative',
}

const _base = 'discountMethod';
const totalBuy = [_base, 'buysQty'];
const totalGet = [_base, 'getsQty'];
const discountValue = [_base, 'discountValue'];
const percentage = [_base, 'percentage'];
const reductionAmount = [_base, 'reductionAmount'];
const scope = [_base, 'discountItemScope'];
const productTable = [_base, 'products'];
const collectionTableName = [_base, 'collections'];
const cumulative = ['applyTo', 'cumulative'];
const cumulativeType = [_base, 'cumulativeType'];
const maxSelectionEnabled = [_base, 'maxSelectionEnabled'];
const maxSelection = [_base, 'maxSelection'];
const excludeFlashSales = ['applyTo', 'flashSaleExcluded'];

const Buy1Get1Free = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency, form, disableEdit } = props;

  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      title={getI18n('salesChannelDirectDiscount.discountValue.discountValue')}>
      <Section bottomBorder className={css.innerSection}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'salesChannelDirectDiscount.discountValuebuyOne.totalBuys(Qty)',
                  )}*`}>
                  <Item
                    name={totalBuy}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isInteger(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.pleasefillaninteger')),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(`${getI18n('general.noLessThan')} 1`),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      disabled={disableEdit}
                      //  precision={0}
                      // formatter={limitNumber}
                      // parser={limitNumber}
                    />
                  </Item>
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'salesChannelDirectDiscount.discountValuebuyOne.getsQty',
                  )}*`}>
                  <Item
                    shouldUpdate={(p, c) => {
                      const cTotalBuy = get(c, totalBuy);
                      const pTotalBuy = get(p, totalBuy);
                      const cTotalGet = get(c, totalBuy);
                      const pTotalGet = get(p, totalBuy);
                      return cTotalBuy !== pTotalBuy || cTotalGet !== pTotalGet;
                    }}>
                    {({ getFieldValue }) => {
                      const _totalBuy = getFieldValue(totalBuy);
                      const _totalGet = getFieldValue(totalGet);

                      setTimeout(() => {
                        if (isNumber(_totalBuy) && isNumber(_totalGet))
                          form.validateFields([totalGet]);
                      });
                      return (
                        <Item
                          name={totalGet}
                          rules={[
                            {
                              validator: async (x, value) => {
                                if (!isInteger(value)) {
                                  return Promise.reject(
                                    new Error(
                                      getI18n('general.pleasefillaninteger'),
                                    ),
                                  );
                                }
                                if (value > _totalBuy) {
                                  return Promise.reject(
                                    new Error(
                                      getI18n(
                                        'salesChannelDirectDiscount.discountValuebuyOne.valueshouldbenogreaterthantotalbuys',
                                      ),
                                    ),
                                  );
                                }
                                if (value < 1) {
                                  return Promise.reject(
                                    new Error(
                                      `${getI18n('general.noLessThan')} 1`,
                                    ),
                                  );
                                }
                              },
                            },
                          ]}>
                          <OriNumberInput
                            size='large'
                            disabled={disableEdit}
                            // precision={0}
                            // formatter={limitNumber}
                            // parser={limitNumber}
                          />
                        </Item>
                      );
                    }}
                  </Item>
                  {/* <ItemShouldUpdate
                    dependencies={[totalBuy]}
                    childGenerate={({ getFieldValue }) => {
                      const _totalBuy = getFieldValue(totalBuy);
                      console.log('_totalBuy', _totalBuy);
                      setTimeout(() => {
                        form.validateFields([totalGet]);
                      });
                      return (
                        <Item
                          name={totalGet}
                          rules={[
                            {
                              validator: async (x, value) => {
                                if (!isNumber(value)) {
                                  return Promise.reject(
                                    new Error('Please fill this field'),
                                  );
                                }
                                if (value < _totalBuy) {
                                  return Promise.reject(
                                    new Error(
                                      'Value should be no less than total buys',
                                    ),
                                  );
                                }
                              },
                            },
                          ]}>
                          <OriNumberInput size='large' />
                        </Item>
                      );
                    }}
                  /> */}
                </ItemWrapper>
              ),
            },
          ]}
        />
        <ItemWrapper
          title={getI18n(
            'salesChannelDirectDiscount.discountValuebuyOne.ataDiscountValue',
          )}>
          <AtDiscountValue
            currency={currency}
            percentageName={percentage}
            reductionAmountName={reductionAmount}
            radioName={discountValue}
            disableEdit={disableEdit}
          />
        </ItemWrapper>
      </Section>
      <Section bottomBorder className={css.tableSection}>
        <ProductsCollectionRadioTable
          currency={currency}
          collectionTableName={collectionTableName}
          radioName={scope}
          productTableName={productTable}
          productTableId={'SalesChannelDirectDiscountBuy1Get1FreeProductTable'}
          collectionTableId={
            'SalesChannelDirectDiscountBuy1Get1FreeCollectionTable'
          }
          disableEdit={disableEdit}
        />
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item name={excludeFlashSales} valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValue.excludeflashsaleitems',
            )}
          </OriCheckbox>
        </Item>
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item
          name={cumulative}
          valuePropName={'checked'}
          className={css.cumulativeContainer}>
          <OriCheckbox>
            {getI18n(
              'salesChannelDirectDiscount.discountValuebuyOne.cumulativelyapplydiscount',
            )}
          </OriCheckbox>
        </Item>
        <ItemShouldUpdate
          dependencies={[cumulative]}
          childGenerate={({ getFieldValue }) => {
            const isDisplay = getFieldValue(cumulative);
            if (isDisplay) {
              return (
                <div className={css.cumulativeSubContainer}>
                  <Item
                    name={cumulativeType}
                    rules={[{ required: true }]}
                    className={css.cumulativeRadioFormItem}>
                    <RadioGroup className={css.cumulativeRadioGroup}>
                      <RadioItem
                        value={CumulativeType.ConditionOnly}
                        className={css.cumulativeRadioItem}>
                        {getI18n(
                          'salesChannelDirectDiscount.discountValuebuyOne.wheneligibleconditionsaremet',
                        )}
                      </RadioItem>
                      <RadioItem
                        className={css.cumulativeRadioItem}
                        value={CumulativeType.ConditionCumulative}>
                        {getI18n(
                          'salesChannelDirectDiscount.discountValuebuyOne.eligibleconditions',
                        )}
                      </RadioItem>
                    </RadioGroup>
                  </Item>
                  <Item
                    name={maxSelectionEnabled}
                    valuePropName={'checked'}
                    className={css.maxFormItemContainer}>
                    <OriCheckbox>
                      {getI18n(
                        'salesChannelDirectDiscount.discountValuereduction.maximumnumber',
                      )}
                    </OriCheckbox>
                  </Item>
                  <ItemShouldUpdate
                    childGenerate={({ getFieldValue }) => {
                      const isDisplay = getFieldValue(maxSelectionEnabled);
                      if (isDisplay) {
                        return (
                          <Item
                            className={css.numberInput}
                            name={maxSelection}
                            rules={[
                              {
                                validator: async (x, value) => {
                                  if (!isInteger(value)) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'general.pleasefillavalidvalue',
                                        ),
                                      ),
                                    );
                                  }
                                  if (value <= 0) {
                                    return Promise.reject(
                                      new Error(
                                        replaceI18nVariables(
                                          getI18n(
                                            'general.valueshouldbegreaterthan',
                                          ),
                                          0,
                                        ),
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}>
                            <OriNumberInput size='large' />
                          </Item>
                        );
                      }
                      return null;
                    }}
                    dependencies={[maxSelectionEnabled]}
                  />
                </div>
              );
            }
            return null;
          }}
        />
      </Section>
      <Tip
        title={getI18n(
          'salesChannelDirectDiscount.discountValue.discountCalculationrule',
        )}
        content={getI18n(
          'salesChannelDirectDiscount.discountValuebuyOne.lastTip',
        )}
      />
    </SectionWrapper>
  );
};
export default Buy1Get1Free;
